import { Stack } from "@mui/material"
import { cloneElement } from "react"

interface IProps {
  cards: JSX.Element[],
  showCardNumbers?: boolean
}

const Form = ({cards, showCardNumbers}: IProps) => {
  return (
    <Stack spacing={2} sx={{width:"100%"}}>
      {cards.map((card, index) => showCardNumbers ? cloneElement(card, {cardNumber: index + 1, key: index + 1}) : cloneElement(card, {key: index + 1}))}
    </Stack>
  )
}

export default Form